<template>
  <div class="header-page">
    <div class="notice">
      <div class="contcontent container">
        <div class="left">
          <div class="cont">
            <img class="icon-img" src="@/assets/images/notice.svg" />
            <div class="swiper-page">
              <vue-marquee-slider :speed="10000" :space="60" :reverse="false" id="marquee1">
                <template v-for="value in noticeString">
                  <span class="marquee-item">{{ value }}</span>
                </template>
              </vue-marquee-slider>
            </div>
            <el-popover v-model="noticePopover" placement="bottom-end" width="550" trigger="click"
              :visible-arrow="false">
              <div class="notice-detail">
                <div class="notice-title">
                  <img class="icon-img" src="@/assets/images/notice.svg" />
                  <span>公告</span>
                  <img class="icon-img icon2 cur-poi" src="@/assets/images/noticeicon.svg"
                    @click="noticePopover = !noticePopover" />
                </div>
                <div class="notice-cont">
                  <template v-for="item in notice">
                    <span v-html="item.content"></span>
                    <el-divider></el-divider>
                  </template>
                </div>
              </div>
              <img slot="reference" class="cur-poi icon-img" src="@/assets/images/noticeicon.svg" />
            </el-popover>
          </div>
        </div>
        <div class="right">
          <div class="item" @click="setHomepage">
            <img src="@/assets/images/setHome.svg" />
            <span>设为首页</span>
          </div>
          <div class="item" @click="addFavorite">
            <img src="@/assets/images/scbz.svg" />
            <span>收藏本站</span>
          </div>
        </div>
      </div>
    </div>
    <div class="logo">
      <div class="container">
        <div class="left">
          <img class="logo-img" :src="head_logo" />
          <img class="icon-img" :src="head_icon" />
        </div>
        <img class="tip-img" :src="head_image" />
      </div>
    </div>
    <headerMenu></headerMenu>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import headerMenu from './headerMenu.vue'

export default {
  name: 'headerPage',
  components: {
    headerMenu,
  },
  computed: {
    ...mapState(['config']),
    notice() {
      return this.config.notice || []
    },
    noticeString() {
      return this.notice.map(item => {
        // console.log(11)
        return richTextToText(item.content)
      })
    },
    head_logo() {
      return this.config.head_logo || require('@/assets/images/kai-logo.png')
    },
    head_icon() {
      return this.config.head_icon || require('@/assets/images/loginTit_03.png')
    },
    head_image() {
      return this.config.head_image || require('@/assets/images/kaiTop.png')
    },
  },
  data() {
    return {
      noticePopover: false,
    }
  },
  methods: {
    setHomepage,
    addFavorite
  },
}

/**
    * 富文本标签过滤
    */
function richTextToText(html = '') {
  return html
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\s+/g, ' ')
    .trim()
}
/**
    * 设为首页功能
    * 注意：此功能主要对 IE 浏览器有效，现代浏览器（Chrome, Firefox, Edge）出于安全考虑已不支持。
    */
function setHomepage() {
  var url = window.location.href;  // 获取当前页面完整网址
  var isSupported = false;

  // 针对 IE 浏览器 (使用默认行为)
  if (document.all) {
    try {
      // 此方法仅对 IE 有效
      document.body.style.behavior = 'url(#default#homepage)';
      document.body.setHomePage(url);
      isSupported = true;
    } catch (e) {
      console.log(e);
    }
  }
  // 针对 Firefox 部分旧版本以及部分早期浏览器
  else if (window.netscape && netscape.security.PrivilegeManager) {
    try {
      netscape.security.PrivilegeManager.enablePrivilege("UniversalXPConnect");
      var prefs = Components.classes['@mozilla.org/preferences-service;1'].getService(Components.interfaces.nsIPrefBranch);
      prefs.setCharPref('browser.startup.homepage', url);
      isSupported = true;
    } catch (e) {
      console.log(e);
    }
  }

  if (!isSupported) {
    alert('您的浏览器不支持自动设置首页。\n\n您可以将「' + url + '」手动设置为首页。\n\n设置方法：在浏览器设置中找到「启动时打开」或「主页」选项，粘贴此网址即可。');
  } else {
    alert('设置成功！已将当前页面设为首页。');
  }
}

/**
 * 添加到收藏夹/书签功能
 * 兼容 Chrome, Firefox, IE 等，对于不支持的现代浏览器会给出快捷键提示。
 */
function addFavorite() {
  var title = document.title;          // 获取网页标题
  var url = window.location.href;      // 获取当前页面URL
  var isSupported = false;

  // IE 浏览器
  if (window.external && 'AddFavorite' in window.external) {
    window.external.AddFavorite(url, title);
    isSupported = true;
  }
  // Firefox 旧版本 (Version < 23)
  else if (window.sidebar && window.sidebar.addPanel) {
    window.sidebar.addPanel(title, url, '');
    isSupported = true;
  }
  // Opera 旧版本
  else if (window.opera && window.print) {
    var elem = document.createElement('a');
    elem.setAttribute('href', url);
    elem.setAttribute('title', title);
    elem.setAttribute('rel', 'sidebar');
    elem.click();
    isSupported = true;
  }

  // 如果不支持自动添加（Chrome, Edge, 新版Firefox等）
  if (!isSupported) {
    // 提示用户使用快捷键 Ctrl+D (Windows/Linux) 或 Cmd+D (Mac)
    var isMac = navigator.userAgent.indexOf('Mac') !== -1;
    var shortcut = isMac ? 'Cmd + D' : 'Ctrl + D';
    alert('您的浏览器不支持一键添加。\n\n请使用快捷键 ' + shortcut + ' 手动将此页面添加到书签。');
  }
}
</script>
<style scoped lang="scss">
.header-page {
  background-color: #0000;

  .logo {
    background-color: #fff;

    .container {
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        cursor: pointer;
      }

      .left {
        display: flex;
        align-items: center;
        gap: 16px;

        .logo-img {
          // width: 165px;
          width: auto;
          height: 62px;
        }

        .icon-img {
          // width: 172px;
          width: auto;
          height: 29px;
        }
      }

      .tip-img {
        width: auto;
        height: 100%;
      }
    }
  }

  .notice {
    background-color: #f6f6f6;

    .contcontent {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;

      .left {
        .cont {
          display: flex;
          align-items: center;
          gap: 5px;

          .icon-img {
            width: 20px;
            height: auto;
          }

          .swiper-page {
            width: 500px;

            .marquee-item {
              display: inline-block;
              white-space: nowrap;
              min-width: auto !important;
              font-size: 12px;
              font-weight: 400;
              color: #313131;
            }
          }
        }
      }

      .right {
        display: flex;
        align-items: center;
        gap: 20px;

        .item {
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 5px;

          img {
            // width: 12px;
            // height: 12px;
          }

          span {
            font-size: 12px;
            font-weight: 400;
            color: #9b9b9b;
          }
        }
      }
    }
  }
}

.notice-detail {
  .notice-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    span {
      flex: 1;
      color: #5f5f5f;
      font-size: 18px;
    }

    .icon-img {
      width: 30px;
      height: auto;

      &.icon2 {
        transform: rotate(90deg);
      }
    }
  }

  .notice-cont {
    padding: 16px 26px 0px;
  }
}
</style>
